import React, { useState } from 'react';
import { Card, Col, Row, Statistic, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useCurrency } from '@/contexts/CurrencyContext';
import salesConversionReportsService from '@/services/salesConversionReports.service';
import { defaultSalesReportFilters, SalesReportFilterBar } from './SalesReportFilterBar';

const { Title } = Typography;

const SalesBookingBillingBridgePage: React.FC = () => {
  const { formatCurrency } = useCurrency();
  const [filters, setFilters] = useState(defaultSalesReportFilters());
  const { data, isLoading } = useQuery({
    queryKey: ['sales-booking-billing', filters],
    queryFn: () => salesConversionReportsService.bookingBillingCollections(filters),
  });

  const current = (data?.current as Record<string, unknown>) || {};
  const prior = (data?.prior as Record<string, unknown>) || {};

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Booking → billing → collections</Title>
      <SalesReportFilterBar value={filters} onChange={setFilters} />
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} md={8}>
          <Card loading={isLoading}>
            <Statistic title="SO booked" value={formatCurrency(Number(current.booked_value || 0))} />
            <div>{Number(current.so_count || 0)} orders</div>
            {prior.booked_value != null ? (
              <div style={{ color: '#666' }}>Prior {formatCurrency(Number(prior.booked_value))}</div>
            ) : null}
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card loading={isLoading}>
            <Statistic title="Invoiced" value={formatCurrency(Number(current.invoiced_value || 0))} />
            <div>
              {Number(current.invoice_count || 0)} invoices
              {current.billing_vs_booking_pct != null ? ` · ${current.billing_vs_booking_pct}% of booked` : ''}
            </div>
            {prior.invoiced_value != null ? (
              <div style={{ color: '#666' }}>Prior {formatCurrency(Number(prior.invoiced_value))}</div>
            ) : null}
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card loading={isLoading}>
            <Statistic title="Collected" value={formatCurrency(Number(current.collected_value || 0))} />
            <div>
              {Number(current.receipt_count || 0)} receipts
              {current.collection_vs_billing_pct != null
                ? ` · ${current.collection_vs_billing_pct}% of invoiced`
                : ''}
            </div>
            {prior.collected_value != null ? (
              <div style={{ color: '#666' }}>Prior {formatCurrency(Number(prior.collected_value))}</div>
            ) : null}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SalesBookingBillingBridgePage;
